export default __webpack_public_path__ + "static/media/054---task-work-flow-.f7c15d68.svg";